import * as React from "react"
import parse from 'html-react-parser'
import { useStaticQuery,graphql } from "gatsby"
import { useLocation } from '@reach/router'

import { PrepMedia } from "../utils/globalUtils"
import GRMbanner from "./grm-banner"
import '../../static/fonts/fonts.min.css'
import '../styles/dynamic/elementor.min.css'

import '../styles/global.scss'

import build from '../../__build.json'


const Layout = ( props ) => {
    const location = useLocation()
    const query = useStaticQuery(graphql`
        query headerFooter {
            wp {
                elementorCssKit
                elementorHF
                languages {
                    locale
                }
            }
        }
    `)
    const elementorHF  = JSON.parse(query.wp.elementorHF)
    const activeKitId  = JSON.parse(query.wp.elementorCssKit).activeKitId

    let pageCss = '/css'+ location.pathname +'page.min.css?t='+ build.timestamp
    let { 
        id, 
        className, 
        children, 
        wrapperClass,
        bannerData,
        bannerImage,
        langCode,
        style
    } = props
    let headerContent = elementorHF.header[langCode].content
    let footerContent = elementorHF.footer[langCode].content
    let postClass = ( typeof id !== 'undefined' ) ?
        ' post-'+ id : ' ' 
    
    if ( headerContent ) {
        headerContent = headerContent.replace('href=""', 'href="/"')
            .replace('<ul ', '<ul style="pointer-events: none;" ')

        headerContent = headerContent.replace(
            /(href=")/gm, 
            'data-lang="'+ langCode +'" href="'
        )

        headerContent = ( langCode !== 'en' ) ? 
            headerContent.replace( 'href="/"', 'href="/'+ langCode +'/"' ) : 
            headerContent
    }
    
    wrapperClass = wrapperClass || ''
    style = {
        ...style,
        overflow: 'hidden'
    }

    footerContent = footerContent.replace(
        /(href=")/gm, 
        'data-lang="'+ langCode +'" href="'
    )

    if ( /\/knowledge\/(?!faqs)/.test(location.pathname) )
        pageCss = false

     return(
        <div id="grm-site-wrapper" 
            style={ style }
            className={
                "elementor-default"+ postClass +" "+
                "elementor-kit-"+ activeKitId +" "+ 
                wrapperClass + className
        }>
            <header id="global-header">
                {
                    headerContent &&
                    parse(headerContent, { replace: PrepMedia })
                }
            </header>

            {
                bannerData &&
                <GRMbanner bannerData={bannerData} 
                    bannerImage={bannerImage} />
            }
            
            <main id="content" className={className}>
                {children}
            </main>
            <footer id="global-footer">
                {
                    footerContent &&
                    parse(footerContent, { replace: PrepMedia })
                }
            </footer>
            {
				pageCss &&
				<link rel="stylesheet" data-chead 
                    href={pageCss} />
			}
            <link rel="stylesheet" data-chead 
				href={
                    '/css/footer-'+ langCode +
                    '.min.css?t=' + build.timestamp
                    } 
                />
        </div>
    )
} 

export default Layout